// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { AlertSuccess } from '@rover/icons';
import { Heading, Text } from '@rover/kibble/components';
import { DSTokenMap } from '@rover/kibble/styles';
import { ContactInfoConstants } from '@rover/shared/js/constants/translation';

type Props = {
  isComplete: boolean,
  titleText: string,
  incompleteText?: string,
};

const SectionTitleWrapper: StyledComponent<{}> = styled.div`
  position: relative;
`;

const SectionTitleHeading: StyledComponent<{}> = styled(Heading)`
  margin-bottom: 0;
`;

const Circle: StyledComponent<{}> = styled.div`
  border: 1px solid ${DSTokenMap.BORDER_COLOR_PRIMARY};
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  left: -45px;
`;

const StyledAlertSuccess: StyledComponent<
  React$ElementConfig<typeof AlertSuccess>,
  {},
  any
> = styled(AlertSuccess)`
  fill: ${DSTokenMap.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE};
  position: absolute;
  left: -45px;
`;

const StyledSubHeading: StyledComponent<{ isComplete: boolean }> = styled(Text)`
  color: ${(props) =>
    props.isComplete
      ? DSTokenMap.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE
      : DSTokenMap.TEXT_COLOR_ERROR};
  margin-bottom: ${DSTokenMap.SPACE_2X};
`;

const renderSubheading = (isComplete: boolean, incompleteText: string) =>
  isComplete ? (
    <StyledSubHeading as="div" size="200" isComplete={isComplete}>
      {ContactInfoConstants.complete}
    </StyledSubHeading>
  ) : (
    <StyledSubHeading as="div" size="200" isComplete={isComplete}>
      {incompleteText}
    </StyledSubHeading>
  );

const SectionTitle = ({
  isComplete,
  titleText,
  incompleteText = ContactInfoConstants.incomplete,
}: Props): Node => (
  <SectionTitleWrapper>
    {isComplete ? <StyledAlertSuccess /> : <Circle />}
    <SectionTitleHeading size="300">{titleText}</SectionTitleHeading>
    {renderSubheading(isComplete, incompleteText)}
  </SectionTitleWrapper>
);

export default SectionTitle;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/common/SectionTitle.jsx